import React, { useContext, useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import AuthContext from "../../../contexts/AuthContext/AuthContext";
import "../Auth.css";

// /verify-email/:uid/:token — the link in the welcome email. The player can
// already play; this only confirms their address.
const VerifyEmailPage = () => {
  const { uid, token } = useParams();
  const { isSignedIn, updateUser } = useContext(AuthContext);
  const navigate = useNavigate();
  const [state, setState] = useState({ status: "checking", message: "" });

  const SERVER_URL = process.env.REACT_APP_SERVER_URL;

  useEffect(() => {
    let alive = true;
    axios
      .post(`${SERVER_URL}/api/verify-email/`, { uid, token })
      .then(() => {
        if (!alive) return;
        setState({ status: "done", message: "" });
      })
      .catch((err) => {
        if (!alive) return;
        setState({
          status: "failed",
          message:
            err.response?.data?.detail ||
            "We couldn't confirm your email. Please try again later.",
        });
      });
    return () => {
      alive = false;
    };
  }, [uid, token, SERVER_URL]);

  useEffect(() => {
    if (state.status === "done" && isSignedIn && updateUser) {
      updateUser({ email_verified: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.status, isSignedIn]);

  return (
    <div className="auth-page">
      <Helmet>
        <title>Confirm your email – Mend Grove</title>
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      <div className="auth-card" aria-live="polite">
        <h2 className="auth-title">
          {state.status === "failed" ? "That link didn't work" : "Confirm your email"}
        </h2>
        {state.status === "checking" && (
          <p className="auth-message auth-message--info">Confirming your email...</p>
        )}
        {state.status === "done" && (
          <p className="auth-message auth-message--success">
            Thank you. Your email address is confirmed.
          </p>
        )}
        {state.status === "failed" && (
          <p className="auth-message auth-message--error">{state.message}</p>
        )}
        {state.status !== "checking" && (
          <button
            type="button"
            className="auth-submit"
            onClick={() => navigate(isSignedIn ? "/home" : "/signin")}
          >
            {isSignedIn ? "Go to the games" : "Sign in"}
          </button>
        )}
      </div>
    </div>
  );
};

export default VerifyEmailPage;
